var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('how-we-counted'),_c('foot-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }